import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import {get,post} from "../../network/axiosServices";


const initialState = {
    loading: false,
    posts: [],
    error: '',
}

export const fetchAbout = createAsyncThunk("fetchAbout", (params) => {
    return get(params);
});


const postSlice = createSlice({
    name: 'about',
    initialState,
    extraReducers: builder => {
        builder.addCase(fetchAbout.pending, (state) => {
            state.loading = true
            state.posts = []
            state.error = ''
        })
        builder.addCase(fetchAbout.fulfilled, (state, action) => {
            state.loading = false
            state.posts = action.payload
            state.error = ''
        })
        builder.addCase(fetchAbout.rejected, (state, action) => {
            state.loading = false
            state.posts = []
            state.error = action.error
        })

   }
})


export default postSlice.reducer
